import createCache from '@emotion/cache';

export const EMOTION_CACHE_KEY = 'css';

export function createEmotionCache() {
  return createCache({ key: EMOTION_CACHE_KEY, prepend: true });
}
